"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var PropertyEditorInternalContext = _react["default"].createContext({
  fields: [],
  fieldPortalValuesOnlyUseForFieldPortalsAllOtherUseCasesWillBreakTheControlledPropertyEditor: {},
  // im not kidding, what ever you want fix it in the schema resolver
  additionalFieldTypes: [],
  // only used for <Field />, <PropertyEditor /> will use the public PropertyEditorContext to get the additional fields
  visibleFieldIds: [],
  // only used for <RestField />
  registerFieldId: function registerFieldId() {},
  // only used for <RestField />
  onChange: function onChange(fieldId, value) {},
  onBlur: function onBlur(fieldId) {},
  hasRestFields: function hasRestFields() {}
});

var _default = PropertyEditorInternalContext;
exports["default"] = _default;